const normalizedIdentity = (value) =>
  String(value ?? "").trim().toLocaleLowerCase();

const normalizeUnitCode = (unit) =>
  String(unit.unitCode || unit.unitName || "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 24);

export const createPurchaseUnitDraft = (overrides = {}) => ({
  key: overrides.key,
  unitName: overrides.unitName || "",
  unitCode: overrides.unitCode || "",
  conversionFactor: overrides.isBaseUnit
    ? "1"
    : String(overrides.conversionFactor ?? "1"),
  barcode: overrides.barcode || "",
  isBaseUnit: Boolean(overrides.isBaseUnit),
  allowSharedBarcode: Boolean(overrides.allowSharedBarcode),
});

export const getReceivingUnit = (units, receivingUnitKey) =>
  (units || []).find((unit) => unit.key === receivingUnitKey) || null;

export const normalizePurchaseUnitDraft = (units = []) =>
  units.map((unit) => ({
    client_key: String(unit.key || "").trim(),
    unit_name: String(unit.unitName || "").trim(),
    unit_code: normalizeUnitCode(unit),
    conversion_factor: unit.isBaseUnit ? 1 : Number(unit.conversionFactor),
    barcode: String(unit.barcode || "").trim() || null,
    is_base_unit: Boolean(unit.isBaseUnit),
    allow_shared_barcode: Boolean(unit.allowSharedBarcode),
  }));

export function validatePurchaseUnitDraft({
  units = [],
  receivingUnitKey,
  scannedBarcode,
}) {
  const errors = {};
  const rows = {};
  const baseUnits = units.filter((unit) => unit.isBaseUnit);
  if (baseUnits.length !== 1) {
    errors.base = "Choose exactly one base unit.";
  }

  units.forEach((unit, index) => {
    const rowErrors = [];
    if (!String(unit.unitName || "").trim()) {
      rowErrors.push("Enter a unit name.");
    }
    const factor = Number(unit.conversionFactor);
    if (!Number.isSafeInteger(factor) || factor < 1) {
      rowErrors.push("Conversion factor must be a positive whole number.");
    }
    if (unit.isBaseUnit && factor !== 1) {
      rowErrors.push("The base unit conversion factor must be 1.");
    }
    if (!String(unit.key || "").trim()) {
      rowErrors.push("Unit identity is missing.");
    }
    if (rowErrors.length) rows[index] = rowErrors;
  });
  if (Object.keys(rows).length) errors.rows = rows;

  const names = units.map((unit) => normalizedIdentity(unit.unitName)).filter(Boolean);
  if (new Set(names).size !== names.length) {
    errors.names = "Unit names must be unique.";
  }
  const barcodes = units.map((unit) => normalizedIdentity(unit.barcode)).filter(Boolean);
  if (new Set(barcodes).size !== barcodes.length) {
    errors.barcodes = "Unit barcodes must be unique.";
  }

  const receivingUnit = getReceivingUnit(units, receivingUnitKey);
  if (!receivingUnit) {
    errors.receivingUnit = "Choose which unit was scanned.";
  } else if (
    !normalizedIdentity(scannedBarcode) ||
    normalizedIdentity(receivingUnit.barcode) !== normalizedIdentity(scannedBarcode)
  ) {
    errors.receivingUnit = "The scanned barcode must belong to the receiving unit.";
  }
  return errors;
}
